module.exports = __webpack_public_path__ + "img/open-book.37b2ba1e.svg";